<template>
  <div class="parkApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" :element-loading-text="tsmsg" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <swiper :options="swiperOption">
      <swiper-slide class="swiper-slide games" >
        <a href=""><img :src="baseUrl+setScenic.img"></a>
      </swiper-slide>
    </swiper>
    <div class="cont">
      <div class="info">
        <h2 class="title"><div>{{setScenic.title}}</div>
          <span class="curt">{{setScenic.level}}级景区</span>
          <span>{{setScenic.read_num}}次查阅</span>
        </h2>
        <h2>景区地址：{{setScenic.address}}</h2>
        <h2 style="padding-bottom:10px">
          <p>周一至周日</p>
          <p>入场时间：{{setScenic.business}}</p>
          <p>以上信息仅供参考，具体以景区当日实际公示信息为准。</p>
        </h2>
        <h2 class="box">请输入姓名
          <div class="right"><input v-model="name" type="text" placeholder="姓名，以免影响出票" value=""></div>
        </h2>
        <h2 class="box">请输入联系电话
          <div class="right"><input v-model="phone" type="text" placeholder="联系电话，以免影响出票" value=""></div>
        </h2>
        <h2 class="box">请输入身份证号
          <div class="right"><input v-model="idcard" type="text" placeholder="身份证号，以免影响出票" value=""></div>
        </h2>
        <div class="goDetail" @click="toPush(setScenic.id,'tkscenic')">详情<i class="el-icon-arrow-right"></i></div>
      </div>
    </div>
    <div style="height:20px"></div>
    <div class="footer1">
      <div class="foot-title">
        <span>今日剩余{{setScenic.quota - setScenic.total}}张</span>
      </div>
      <div class="pay" v-if="(setScenic.quota - setScenic.total) <= 0">
        <span style="background:#ccc">已领取完毕</span>        
      </div>
      <div class="pay" @click="save" v-if="(setScenic.quota - setScenic.total) > 0">
        <span>领取门票</span>        
      </div>
    </div>


    <el-dialog title="恭喜您，门票领取成功！" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <div v-if="setScenic.id != 10">
        <img id="avatar" :src="userData.avatar" />
        <div id="username">{{userData.username}}</div>
        <div class="c55">
        <div id="username">{{codeCard == -1 ? '门票领取成功' : '您的取票码为：'+codeCard+'，切记您的取票码'}}</div>
        <div id="username">{{codeCard == -1 ? '请到景区门口告知管理员是公园卡用户，然后扫码入园' : '请到对应取票机取票'}}</div>
        </div>
        <div style="text-align:center;padding-top:20px;padding-bottom:25px;color:#f00;font-weight:bold;font-size:16px"></div>
      </div>
      <div v-if="setScenic.id == 10" >
        <img :src="images" style="display:block;margin:0 auto" />
        <div id="username" style="font-size:14px;color: #666666">请在闸机上刷码入园或用公园卡实名制身份证刷闸机入园</div>
        <div id="username" style="font-size:16px;color: #f00;font-weight:bold">请刷码入园！</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        tsmsg:'数据加载中',
        swiperOption: {
          autoplay : {
            disableOnInteraction: false, //用户操作后是否禁止自动循环
            delay: 1000 //自自动循环时间
          }, //可选选项，自动滑动
          initialSlide: 0,
          speed: 1000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
          loop:false, //循环切换
          grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
          autoHeight: true,   //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true, //设置为true时，能使用鼠标滚轮控制slide滑动
          observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
       
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },
        dialogFormVisible: false,
        images:'',
        setScenic:[],
        name:'',
        phone:'',
        idcard:'',
        codeCard:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/mpark?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.getScenic();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      getScenic:function(e){
        var that = this;
        var id = that.$route.query.id;
        this.axios({
          'url': that.$host+'home/crowd/scenic',
          'method': 'post',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setScenic = res;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      save:function(){
        var that = this;
        var id = that.$route.query.id;
        if(that.name == ''){
          that.$alert('请输入姓名!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if(that.phone == ''){
          that.$alert('请输入联系电话!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if(that.idcard == ''){
          that.$alert('请输入身份证号!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        that.tsmsg = '正在出票中...';
        that.fullscreenLoading = true;
        that.axios({
          'url': that.$host+'home/crowd/savePark',
          'method': 'post',
          params:{
            user_id:that.userData.id,
            phone:that.phone,
            name:that.name,
            s_id:that.setScenic.id,
            id:id,
            idcard:that.idcard,
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          var res = response.data.data
          if(response.data.status == 200){
            that.dialogFormVisible = true;
            if(that.setScenic.id == 10){
              that.images = 'data:image/jpeg/png;base64,'+res.img;
            }else{
              that.codeCard = res.code;
            }
            that.getScenic();
            that.tsmsg = '数据加载中';
          }else{
            that.$alert(response.data.message, '提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },


      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .el-dialog{
    width:90% !important;
    border-radius:6px;
  }
  .el-dialog__body{
    padding:20px 20px 0 20px !important;
  }
  .el-form-item__content{
    margin-left:0 !important
  }
  .el-form-item__label{
    text-align:left
  }
  .parkApp{
    max-width:640px;
    background:#f1f1f1;
    margin:0 auto;
  }
  .parkApp .swiper-slide{
    width:100%
  }
  .parkApp .swiper-slide img{
    display:block;
    width:100%;
  }
  .parkApp .cont{
    width:94%;
    display:block;
    margin:0 auto;
    z-index:99;
    position:relative;
    top:-60px;
  }
  .parkApp .info{
    width:100%;
    display:block;
    position:relative;
    background:#fff;
    border-radius:6px;
  }
  .parkApp .info .goDetail{
    position:absolute;
    right:3%;
    transform: translateY(-50%);
    top:20%;
    font-size:14px;
    color:#666
  }
  .parkApp .info h2{
    font-size:15px;
    padding-top:10px;
    width:92%;
    display:block;
    margin:0 auto;
    font-weight:normal;
    color:#333;
  }
  .parkApp .info h2.box{
    border-top:solid 1px #f5f5f5;
    padding:18px 0;
    color:#666
  }
  .parkApp .info h2 .right{
    float:right;
    width:60%;
    text-align:right
  }
  .parkApp .info h2 .right input{
    color:#000;
    float:right;
    width:94%;
    font-size:14px;
    text-align:right;
    outline:none;
    border:none;
    background:#f1f1f1;
    padding:5px 3% 5px 0;
    border-radius:4px;
  }
  .parkApp .info h2 p{
    padding-bottom:5px;
    line-height:22px
  }
  .parkApp .info h2.title{
    color:#000;
    font-weight:bold;
    font-size:16px;
    padding:15px 0 12px 0
  }
  .parkApp .info h2.title div{
    margin-bottom:8px
  }
  .parkApp .info h2.title span{
    font-weight:normal;
    display:inlie-block;
    border:solid 1px #F56C6C;
    font-size:12px;
    padding:3px 5px;
    border-radius: 4px;
    color:#F56C6C;
    margin-right:8px;
  }
  .parkApp .info h2.title span.curt{
    color:#67C23A;
    border-color:#67C23A
  }
  .parkApp .info h2 a{
    color:#2F78FF;
    text-decoration: none;
  }

  
  .parkApp .el-drawer__open .el-drawer.btt{
    border-radius:16px 16px 0 0;
  }
  .parkApp .el-drawer__header{
    margin:0 auto !important;
    padding:0 3%;
    height:50px;
    width:94%;
    position: absolute;
    top:0;
    left:0%;
    z-index:999;
    border-bottom:1px #f5f5f5 solid;
    background:#fff;
    text-align:center;
    color:#000
  }
  .parkApp .yesBtn{
    width:100%;
    position: absolute;
    top:0;
    left:0%;
    height:50px;
    z-index:9999;
  }
  .parkApp .yesBtn a{
    float:right;
    margin-right:4%;
    height:50px;
    line-height:50px;
    color:#0059D6;
    font-size:15px;
    letter-spacing:1px
  }
  .parkApp .yesBtn i{
    float:left;
    margin-left:4%;
    height:50px;
    line-height:50px;
    color:#000;
    font-size:18px
  }
  .parkApp .el-drawer__body ul{
    padding-top:65px;
  }
  .parkApp .el-drawer__body ul li{
    width:92%;
    margin:0 auto;
    border-bottom:solid 1px #f5f5f5;
    margin-bottom:15px;
    padding-bottom:15px;
  }
  .parkApp .el-drawer__body ul li:last-child{
    border-bottom:none;
    padding-bottom:0;
  }
  .parkApp .el-drawer__body ul li:after{
    content: '';
    height: 0;
    line-height: 0;
    display: block;
    visibility: hidden;
    clear: both;
  }
  .parkApp .el-drawer__body ul li .chooseInfo{
    float:left;
    width:20px;
    height:20px;
    margin-top:23px;
    margin-right:4%
  }
  .parkApp .el-drawer__body ul li .chooseInfo font{
    display:block;
    width:20px;
    height:20px;
    border:solid #000000 1px;
    border-radius:50%;
    line-height:20px;
    color:#000
  }
  .parkApp .el-drawer__body ul li .curt font{
    border:none;
    font-size:23px;
  }
  .parkApp .el-drawer__body ul li .cardCon{
    float:left;
    width:72%
  }
  .parkApp .el-drawer__body ul li .cardCon h2{
    font-size:15px;
    letter-spacing:1px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .parkApp .el-drawer__body ul li .cardCon p{
    font-size:13px;
    color:#666;
    padding-top:6px
  }
  .parkApp .el-drawer__body ul li .cardCon p font{
    padding-right:10px;
  }
  .parkApp .el-drawer__body ul li .cardCon p font b{
    color:#0059D6;
    padding-right:1px
  }
  .parkApp .el-drawer__body ul li .status{
    float:right;
    font-size:13px;
    color:#333;
    line-height:66px
  }


  .parkApp .footer1{
    height: 60px;
    background: #fff;
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0;
    z-index: 99
  }
  .parkApp .footer1 .foot-title{
    float: left;
    margin-left: 4%;
    height:60px;
    line-height:60px;
  }
  .parkApp .footer1 .foot-title span{
    font-size: 14px;
    color: #727272;
  }

  .parkApp .footer1 .pay{
    float: right;
    color: #fff;
    margin-right: 4%;
    margin-top:5px;
    width:50%
  }
  .parkApp .footer1 .pay span{
    float:left;
    height:50px;
    line-height:50px;
    font-size: 14px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background: #f00;
    border-radius:50px;
  }

  .parkApp .jbht{
    border:4px dashed #ffd700;
    padding-top:15px;
    position:relative;
    bottom:15px;
    border-radius: 6px;
  }
  .parkApp .jbht span{
    position:absolute;
    top:-15px;
    right:-15px;
    color:#f00;
    font-weight:bold;
    border:4px dashed #ffd700;
    border-radius: 50%;
    width:30px;
    height:30px;
    background:#fff;
    font-size:15px;
    line-height:30px;
    text-align:center
  }

  .parkApp .gggg{
    color:red;;
    font-size:18px;
    padding-bottom:35px;
    text-align:center;
  }
  .parkApp #avatar{
    border-radius:50%;
    width:80px;
    display:block;
    margin:0 auto
  }
  .parkApp #username{
    text-align:center;
    font-size:18px;
    color:#000;
    padding:10px 0
  }
  .parkApp .c55{
    width:98%;
    display:block;
    margin:0 auto;
    background: #F7FAFF;
    border-radius: 10px;
  }
  .parkApp .c55 #username{
    color:#666;
    font-size:15px;
  }
  .parkApp .c55 #username font{
    color:#2F78FF
  }
</style>